export enum LayerListId {
  SDDTaiNguyenMoiTruong,
  QuyHoachSDD,
  ThuaDat,
  QHCTHaTangKyThuat,
  NenVeTinh,
  NenDuongPho
}

export interface LayerListItem {
  title: string;
  id: LayerListId;
  avatar?: string;
}

export interface LayerListGroup {
  title: string;
  items: Array<LayerListItem & { isSelected: boolean }>;
}
